<template>
  <div>
    <!-- banner -->
    <Sbanner :detailInfo="details" v-if="details && details.id" />

    <div class="program-detail">
      <div class="container artsContainer" style="min-height:59vh">

        <div class="topInfo">
          <div class="title flex end">
            <div class="flex-bd">
              <h3>{{ details.title }}</h3>
              <div class="prize flex start" v-if="details.activity_name || details.award">
                <i class="iconfont2 icon2-trophy-fill" v-if="details.award" />
                <template v-if="details.activity_name">
                  <router-link target="_blank" :to="{ path: '/activity/' + details.activity_id }" v-if="details.activity_id">
                    <div class="fonts">{{ details.activity_name || '' }}</div>
                  </router-link>
                  <div class="fonts" v-else>{{ details.activity_name }}</div>
                </template>
                <div class="fonts" :class="details.activity_name && details.award ? 'points' : ''" v-if="details.award">{{
                  details.award }}</div>
              </div>
              <div class="tags flex wrap" v-if="details.keywords">
                <span v-for="(item, index) in details.keywords" :key="index">{{ item }}</span>
              </div>
            </div>
            <div class="ml-50 mt-0">
              <Actions v-if="details.id" banner="7" :view="details.browse_count" :collect="details.collect_count"
                :like="details.like_count" :row="details" />
            </div>
          </div>
        </div>

        <div class="subInfo flex wrap">

          <div class="items flex" v-for="(item, index) in infoList" :key="index">
            <label>{{ item.name }}</label>
            <span v-if="item.fields != 'author'">{{ item.value }} {{ item.value && item.pix ? item.pix : '' }}</span>
            <div v-html="item.value" v-else></div>
          </div>
        </div>

        <div>
          <div class="desc" v-html="details.introduce"></div>
          <div class="imgBox" v-if="imgList && imgList.length">

            <!-- swiper1 -->
            <div class="mainBox">
              <div class="mainSwiper">
                <swiper id="gallerys" class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                  <template v-for="(v, i) in imgList">
                    <swiper-slide :key="i" :style="{ height: v.height + 'px' }">
                      <img class="top-image" :src="v.mainUrl" :alt="v.introduce" :data-original="v.originUrl" @error="imgError(v, ['mainUrl', 'originUrl', 'thumbsUrl'])" />
                    </swiper-slide>
                  </template>
                </swiper>
              </div>
              <div class="currIntro">
                {{ currSwiper.introduce || '' }}
              </div>
            </div>
            <!-- swiper2 Thumbs -->
            <div class="thumbsBox">
              <swiper ref="swiperThumbs" class="swiper gallery-thumbs" :options="swiperOptionThumbs">
                <template v-for="(v, i) in imgList">
                  <swiper-slide class="thumbsSlide" :class="[{ actived: currIndex == i }, { arts: catename == 'arts' }]"
                    :key="i" :style="{ backgroundImage: 'url(' + v.thumbsUrl + ')' }"></swiper-slide>
                </template>
              </swiper>
              <div class="swiper-button-next" slot="button-next" @click="toNextThumbs">
                <i class="iconfont icon-arrow-right"></i>
              </div>
              <div class="swiper-button-prev" slot="button-prev" @click="toLastThumbs">
                <i class="iconfont icon-arrow-lift"></i>
              </div>
            </div>
          </div>

        </div>

        <loading v-if="loading" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import Sbanner from '@/components/sbanner.vue'
import loading from "@/components/common/loading.vue"
import Actions from './exhibit/components/Actions.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Viewer from 'viewerjs'
export default {
  components: {
    Sbanner,
    loading,
    Actions,
    swiper,
    swiperSlide
  },
  data() {
    const that = this
    return {
      id: '',
      catename: '',
      details: {},
      loading: true,
      infoList: [
        { name: '报送单位', fields: 'submitted_unit', value: '' },
        { name: '分类标签', fields: 'type_name', value: '' },
        { name: '作者', fields: 'author', value: '' },
        { name: '印章', fields: 'seal', value: '' },
        { name: '品相', fields: 'condition', value: '' },
        { name: '创作时间', fields: 'produce_time', value: '' },
        { name: '工艺类型', fields: 'technology', value: '' },
        { name: '幅数', fields: 'number', value: '' },
        { name: '材质工艺', fields: 'material', value: '' },
        { name: '尺寸', fields: 'size', value: '' },
      ],
      swiperOptionTop: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        initialSlide: 0,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        autoHeight: true,
        on: {
          slideChange(e) {
            const activeIndex = this.activeIndex
            that.slideThumbsTo(activeIndex)
          }
        }
      },
      swiperOptionThumbs: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        on: {
          click(e) {
            const clickedIndex = this.clickedIndex
            that.slideTo(clickedIndex)
          }
        }
      },
      imgList: [],
      currSwiper: {},
      currIndex: 0,
      access: 0,
      tempRoute: ''
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    const { id, catename, access } = this.$route.params
    this.id = id
    this.catename = catename

    if (access) {
      this.access = access.charAt(3)
    }
    this.tempRoute = this.$route.path.replace(/\//g, '-')
    this.initPage()
  },
  methods: {
    initPage() {
      this.getData()
    },
    async getData() {
      const params = {
        id: this.id,
        token: this.$route.params.token
      }
      const res = await this.$api.exhibitApi.GetByIdShow(params)

      const details = res.data || {}
      const artistlist = res.artistlist || []
      details.cover_img = details.cover_img ? res.showpath + details.cover_img : ''
      details.author = artistlist.filter(v => v.artist_typename == '作者').map(v => v.isrc == 1 ? `<a class="cl-red" href="/#/artist/${v.artist_id}">${v.artist_name}</a>` : v.artist_name).join(',')
      details.keywords = this.$utils.splitWord(details.keywords);
      details.collectTotalNum = 0
      details.likeTotalNum = 0

      if (details.category == 3) {
        this.infoList = [
          { name: '报送单位', fields: 'submitted_unit', value: '' },
          { name: '作者', fields: 'author', value: '' },
          { name: '创作时间', fields: 'produce_time', value: '' },
          { name: '工艺类型', fields: 'technology', value: '' },
          { name: '幅数', fields: 'number', value: '' }
        ]
      }

      this.details = {
        ...details,
        number: details.resources && details.resources.length ? details.resources.length + '幅' : ''
      }
      this.infoList.forEach(v => {
        v.value = this.details[v.fields]
      })
      this.infoList = this.infoList.filter(v => v.value)

      let resources = this.details.resources || []
      resources = resources.filter(v => v.cover_img)
      resources = await Promise.all(
        resources.map(async (v) => {
          let cover_img = this.setImage(res.showpath, v.cover_img, '')
          return {
            ...v,
            thumbsUrl: cover_img,
            mainUrl: cover_img,
            originUrl: this.setImage(res.showpath, v.cover_img, '', false, 20),
            thumbs: v.cover_img ? res.showpath + v.cover_img : ''
          };
        })
      );
      this.imgList = resources
      if (!details.cover_img && this.imgList && this.imgList.length) {
        this.details.cover_img = this.imgList[0].mainUrl
      }
      if (this.imgList && this.imgList.length) {
        this.currSwiper = this.imgList[0] || {}
      }

      this.swiperOptionThumbs.centeredSlides = this.imgList && this.imgList.length == 1

      // this.imgList = this.details.pictures ? this.details.pictures.split(',') : []
      this.loading = false
      this.$nextTick(() => {
        this._initViewer()
      })
    },
    slideTo(index) {
      this.currIndex = index
      const swiperTopSwiper = this.$refs.swiperTop.swiper
      this.currSwiper = this.imgList[this.currIndex] || {}
      swiperTopSwiper.slideTo(index, 200)
    },
    slideThumbsTo(index) {
      this.currIndex = index
      const swiperThumbsSwiper = this.$refs.swiperThumbs.swiper
      this.currSwiper = this.imgList[this.currIndex] || {}
      swiperThumbsSwiper.slideTo(index, 200)
    },
    toNextThumbs() {
      if (this.currIndex < this.imgList.length - 1) {
        const index = this.currIndex + 1
        this.currSwiper = this.imgList[this.currIndex] || {}
        this.slideTo(index)
        this.slideThumbsTo(index)
      }
    },
    toLastThumbs() {
      if (this.currIndex > 0) {
        const index = this.currIndex - 1
        this.currSwiper = this.imgList[this.currIndex] || {}
        this.slideTo(index)
        this.slideThumbsTo(index)
      }
    },
    _initViewer() {
      setTimeout(() => {
        if (document.querySelector('#gallerys')) {
          new Viewer(document.querySelector('#gallerys'), {
            url: 'data-original',
            fullscreen: true,
            button: true,
          })
        }
      }, 500)
    },
  }
}
</script>
<style lang="scss">
.artsContainer {
  background-color: #FFF;
  padding: 24px;

  .topInfo {
    .titleRight {
      min-width: 500px;
    }

    .title {
      flex-shrink: 1;

      h3 {
        color: #222222;
        font-size: 24px;
        font-weight: bold;
        margin-right: 24px;
      }
    }
  }

  .subInfo {
    margin-top: 10px;
    padding: 20px 23px 10px;
    border-radius: 3px;
    background: #f6f7fb;

    .items {
      width: 33.33%;
      margin-bottom: 12px;

      label {
        width: 60px;
        color: #6d6d6d;
        text-align: justify;
        text-align-last: justify;
        text-justify: distribute-all-lines;
        margin-right: 15px;
        cursor: default;
      }
    }
  }

  .desc {
    margin-top: 25px;
    line-height: 1.8;
  }

  .imgBox {
    margin-top: 25px;

    .currIntro {
      width: 880px;
      margin: 22px auto;
      line-height: 1.5;
      text-align: center;
      white-space: pre-line;
    }

    .thumbsBox {
      margin: 16px auto 0;
      max-width: 900px;
      position: relative;
      padding: 0 50px;

      .swiper-button-next,
      .swiper-button-prev {
        background: none;

        .iconfont {
          font-size: 30px;
          color: #858585;
        }
      }
    }

    .imgCon {
      width: 100%;
      height: 100%;
    }

    .swiper {
      .swiper-slide {
        background-size: cover;
        background-position: center;
      }

      &.gallery-top {
        height: 782px;

        .top-image {
          display: block;
          margin: 0 auto;
          height: 782px;
          width: 100%;
          object-fit: contain;
          cursor: pointer;
        }
      }

      &.gallery-thumbs {
        height: 83px;
        box-sizing: border-box;
        padding: 0 0;
        width: 100%;

        .swiper-slide {
          width: 122px;
          height: 100%;
          opacity: 1;
          box-sizing: border-box;
          cursor: pointer;

          &.arts {
            width: 50px;
          }
        }

        .actived {
          border: 2px solid #B41717;
        }
      }
    }
  }
}
</style>